<template>
    <div class="inline-flex items-center px-2 py-1 rounded-md min-h-[22px] text-xs font-semibold tracking-wide uppercase bg-black/55 backdrop-blur-md border border-white/15 text-zinc-100 shadow-sm">
        New
    </div>
</template>
